import React from 'react';
import cx from 'classnames';
import { Button as SButton } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Icon } from '@plone/volto/components';
import ctaArrowSVG from '@redturtle/volto-io-studio/icons/button-arrow.svg';

/* STYLE */
import '@redturtle/volto-io-studio/components/Button/Button.less';

/*
  Stili dei bottoni:
  - vis--button-primary
  - vis--button-secondary
  - vis--button-outline
  - vis--button-subsite (colore primario del sottosito o dipartimento)

  extra: Si può usare anche la prop "inverted" per invertire il colore del bottone.
*/

const Button = (props) => {
  const {
    arrow,
    padded,
    wide,
    noradius,
    uppercase,
    color = 'primary',
    ...otherProps
  } = props;
  let classColor = 'vis--button vis--button-' + color;

  let buttonClass = cx(classColor, {
    wide: wide,
    padded: padded,
    uppercase: uppercase,
    noradius: noradius,
    [props.className]: props.className != null,
  });

  return (
    <SButton {...otherProps} color={null} className={buttonClass}>
      <span>{props.children}</span>
      {props.arrow && (
        <Icon className="arrow-button" name={ctaArrowSVG} size="12px" />
      )}
    </SButton>
  );
};

PropTypes.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  arrow: PropTypes.bool,
  wide: PropTypes.bool,
  padded: PropTypes.bool,
  uppercase: PropTypes.bool,
};

export default Button;
